/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import { generateReduxKeys } from '../../utils';

const initialState = generateReduxKeys({
  value: 0,
});

const testSlice = createSlice({
  name: 'test',
  initialState,
  reducers: {
    increment: (state) => {
      localStorage.setItem('value', state.value);
      state.value += 1;
    },
    incrementByAmount: (state, action) => {
      state.value += action.payload;
    },
  },
});

export const { increment, incrementByAmount } = testSlice.actions;

export default testSlice.reducer;
